import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import UnitCategories from '../../../components/stateless/UnitCategories';
import ClassicUnitCategory from '../../../components/stateless/ClassicUnitCategory';

const propTypes = {
  facility: PropTypes.shape({
    settings: PropTypes.shape({
      showUnavailableUnits: PropTypes.bool.isRequired,
    }).isRequired,
    unitSummary: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      availableUnitsCount: PropTypes.number,
      minPrice: PropTypes.number,
      name: PropTypes.string.isRequired,
      siteUnitCategoryId: PropTypes.string.isRequired,
    })),
  }),
  isEditable: PropTypes.bool,
};

const defaultProps = {
  facility: undefined,
  isEditable: undefined,
};

const ClassicUnitCategories = ({ facility, isEditable }) => {
  if (!facility || !facility.unitSummary) {
    return false;
  }

  return (
    <UnitCategories
      theme="classic"
      facility={facility}
      unitSummary={facility.unitSummary}
      isEditable={isEditable}
      unitComponent={ClassicUnitCategory}
    />
  );
};

ClassicUnitCategories.propTypes = propTypes;
ClassicUnitCategories.defaultProps = defaultProps;

ClassicUnitCategories.fragments = {
  facility: gql`
    fragment ClassicUnitCategoriesFacility on Facility {
      settings {
        showUnavailableUnits
      }
      address{
        state
      }
      unitSummary {
        id
        availableUnitsCount
        minPrice
        name
        siteUnitCategoryId
      }
      ...UnitCategoriesFacility
    }

    ${UnitCategories.fragments.facility}
  `,
};

export default ClassicUnitCategories;
